export interface AccountScopeIdentity {
  userId?: string | null;
  userEmail?: string | null;
  companyId?: string | null;
}

/**
 * Stable client-side ownership key for tenant-private state.
 *
 * Company identity is part of the key even when the WorkOS user is unchanged.
 * A missing company remains an explicit null scope and can never collide with
 * a verified company identifier.
 */
export function buildAccountScopeKey({
  userId,
  userEmail,
  companyId,
}: AccountScopeIdentity): string | null {
  const normalizedUserId = userId?.trim() || userEmail?.trim() || "";
  if (!normalizedUserId) return null;
  return JSON.stringify([normalizedUserId, companyId?.trim() || null]);
}
